function openDiscountModal() {
    document.getElementById('discountModal').style.display = 'block';
    document.body.style.overflow = 'hidden';
  }
  function closeDiscountModal() {
    document.getElementById('discountModal').style.display = 'none';
    document.body.style.overflow = 'auto';
  }
  function copyCode(code, btn) {
    navigator.clipboard.writeText(code).then(() => {
      btn.classList.add('copied');
      btn.innerHTML = '<span class="clipboard-icon">✅</span> Copied!';
      setTimeout(() => {
        btn.classList.remove('copied');
        btn.innerHTML = '<span class="clipboard-icon">📋</span> Copy';
      }, 1500);
    });
  }
  window.onclick = function(event) {
    const modal = document.getElementById('discountModal');
    if (event.target == modal) {
      closeDiscountModal();
    }
}